/* eslint react/no-direct-mutation-state: "off", 'jsx-a11y/alt-text': 'off','no-redeclare': 'off','no-dupe-keys': 'off', 'no-loop-func':'off', eqeqeq: 'off', no-unused-vars: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Button, FormGroup, Label, Form, Table } from 'reactstrap';
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import DatePicker from 'react-datepicker';
import DatePickerCustom from '../../../common/DatePicker';
import Conversions from '../../../../Resources/Conversions';
import { makeGetCall } from '../../../../action/tenantAction';
import { GetWorkOrderBuildings, GetWorkOrderBuildingsEquipments, SaveWorkOrder, DeleteAttachment, GetBuildingAssociation, GetWorkorderTechnician, GetWorkOrderEquipments, GetCustomFields,SaveAttachmentToFolder } from '../../../../action/workorderAction';
import SearchableDropDown from './SearchableDropdown';
import SearchableEquipmentDropDown from './SearchableDropdown';
import SearchableSpaceDropDown from './FloorSpaceSearchableDropdown';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { Redirect } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import moment from 'moment';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import { closeModalPopUp } from '../../../../action/modalStateAction';
import { setAmplitudeEvent } from 'amplitude/amplitude';

const ErrorPadding = {
    color: '#D42D27',
    fontfamily: 'Lato',
    fontStyle: 'italic',
    border: '2px solid #D42D27',
    height: '40px',
    padding: '10px',
    float: 'right',
};

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

class CreateWorkOrder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Buildings: (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length) ? this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false) : "",
            SelectedBuildingId: null,
            SelectedFloorId: null,
            TenantName: '',
            TenantId: '',
            TenantLocation: '',
            BuildingId: 0,
            UserId: 0,
            BuildingName: '',
            FloorId: '',
            SuiteId: '',
            RoomId: '',
            RoomName: '',
            ProblemId: 0,
            UrgencyId: 0,
            StatusId: 1,
            EquipmentName: '',
            EquipmentId: 0,
            EquipmentLocation: '',
            IsNonDiscoveredEquipment: 0,
            LogicalBuildingId: 0,
            image_name: '',
            file: '',
            imagePreviewUrl: '',
            Description: '',
            redirectHome: false,
            IsError: false,
            displayImageError:false,
            errorImageName:null,
            errorImageText:" file type not supported",
            error: {
                tenant: false,
                building: false,
                floor: false,
                space: false,
                problem: false,
                description: false,
                urgency: false,
                equip: false,
                assignto: false,
                status: false,
                customname: false,
                notifyOthers: false,
                dueDate: false,
            },
            image_Array: [],
            TenantDropDownStyles: {
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: "9999",
                width: "400px",
                maxHeight: "300px",
                overflowY: "auto",
                zIndex: "9999",
                border: "1px solid black",
                backgroundColor: "white",
                display: "none",
                "overscroll-behavior-y": "contain" 
            },
            EquipmentDropDownStyles: {
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: "9999",
                width: "400px",
                maxHeight: "300px",
                overflowY: "auto",
                zIndex: "9999",
                border: "1px solid black",
                backgroundColor: "white",
                display: "none",
                "overscroll-behavior-y": "contain" 
            },
            SpacesDropDownStyles: {
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: "9999",
                width: "400px",
                maxHeight: "300px",
                overflowY: "auto",
                zIndex: "9999",
                border: "1px solid black",
                backgroundColor: "white",
                display: "none"
            },
            TenantData: [],
            EquipmentData: [],
            SpacesData: [],
            AssociateBuildings: [],
            AssociateTenant: [],
            IsClickSave: false,
            HasEmailAddress: false,
            SelectedNotifyOthersIds:[],
            dueDate: null,
        }
        this.LoadBuildingFloors = this.LoadBuildingFloors.bind(this);
        this.LoadBuildingEquipment = this.LoadBuildingEquipment.bind(this);
        this.ComputeStyle = this.ComputeStyle.bind(this);
        this.ComputeEquipmentStyle = this.ComputeEquipmentStyle.bind(this);
        this.ComputeSpaceStyle = this.ComputeSpaceStyle.bind(this);
        this.setTenant = this.setTenant.bind(this);
        this.setEquipment = this.setEquipment.bind(this);
        this.setSpace = this.setSpace.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.setEquipmentWrapperRef = this.setEquipmentWrapperRef.bind(this);
        this.setSpaceWrapperRef = this.setSpaceWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
        this.preventScrollPropagation = this.preventScrollPropagation.bind(this);
        this.DeleteAttachment = this.DeleteAttachment.bind(this);
        this.SelectUrgency = this.SelectUrgency.bind(this);
        this.SelectProblem = this.SelectProblem.bind(this);
        this.OnSaveWorkOrder = this.OnSaveWorkOrder.bind(this);
        this.OnCancel = this.OnCancel.bind(this);
        this.OnSort = this.OnSort.bind(this);
        this.OnUserChange = this.OnUserChange.bind(this);
        this.OnStatusChange = this.OnStatusChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.dropdown_fields = { text: 'value', value: 'id' };
    }

    componentWillReceiveProps(nextProps) {
        if(this.props != nextProps && this.props.ForEquipment)
        {
            var l_Equipmentdata = [], ActualSiteId = 0;
            if (nextProps.getBuildingEquipments != undefined && nextProps.getBuildingEquipments.length > 0){
                var SiteDetails = nextProps.getWorkOrderBuildings.filter(x => x.id == this.props.AlarmInfo[0].SiteId);
                if(SiteDetails[0] !== undefined && SiteDetails[0] !== null){
                    ActualSiteId = SiteDetails[0].siteId;
                }
                var l_getBuildingEquipments = nextProps.getBuildingEquipments.filter(x => x.siteId == ActualSiteId);
                l_getBuildingEquipments.forEach(building => {
                    if (building.equipment !== undefined && building.equipment !== null && building.equipment.length > 0) {
                        let siteName = building.siteName;
                        building.equipment.forEach(element => {
                            var Equiplineitem = {
                                "Id": element.objectId,
                                "Name": element.objectName,
                                "Location": siteName,
                                "SubId": 0,
                            }
                            l_Equipmentdata.push(Equiplineitem);
                        });
                    }
                });
            }
            if (nextProps.getEquipments != undefined && nextProps.getEquipments.length > 0){
                var l_SelectedBuildingEquipment = nextProps.getEquipments.filter(el => el.siteId == this.props.AlarmInfo[0].SiteId)
                if (l_SelectedBuildingEquipment !== undefined && l_SelectedBuildingEquipment !== null && l_SelectedBuildingEquipment.length > 0) {
                    var Equiplineitem = '';
                    l_SelectedBuildingEquipment.forEach(Equipment => {
                        Equiplineitem = {
                            "Id": Equipment.id,
                            "Name": Equipment.name,
                            "Location": Equipment.buildingName,
                            "SubId": 1,
                        }
                        l_Equipmentdata.push(Equiplineitem);
                    });
                }
            }
            this.setState({ BuildingId: this.props.AlarmInfo[0].SiteId, BuildingName: this.props.AlarmInfo[0].SiteName, EquipmentId: this.props.AlarmInfo[0].EquipmentId, EquipmentName: this.props.AlarmInfo[0].EquipmentName, Description: this.props.AlarmInfo[0].Description, EquipmentData: l_Equipmentdata});     
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('wheel', this.handleMouseScroll);
        document.addEventListener('mousewheel', this.preventScrollPropagation);
    }

    updateDescriptionValue(evt) {
        this.setState({ Description: evt.target.value });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('wheel', this.handleMouseScroll);
        document.removeEventListener('mousewheel', this.preventScrollPropagation); 
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setEquipmentWrapperRef(node) {
        this.equipWrapperRef = node;
    }

    setSpaceWrapperRef(node) {
        this.spaceWrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            let StateChange = { ...this.state.TenantDropDownStyles };
            StateChange.display = "none";
            this.setState({ TenantDropDownStyles: StateChange });
        }
        if (this.equipWrapperRef && !this.equipWrapperRef.contains(event.target)) {
            let EStateChange = { ...this.state.EquipmentDropDownStyles };
            EStateChange.display = "none";
            this.setState({ EquipmentDropDownStyles: EStateChange });
        }
        if (this.spaceWrapperRef && !this.spaceWrapperRef.contains(event.target)) {
            let SStateChange = { ...this.state.SpacesDropDownStyles };
            SStateChange.display = "none";
            this.setState({ SpacesDropDownStyles: SStateChange });
        }
    }

    handleMouseScroll(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            let StateChange = { ...this.state.TenantDropDownStyles };
            StateChange.display = "none";
            this.setState({ TenantDropDownStyles: StateChange });
        }
        if (this.equipWrapperRef && !this.equipWrapperRef.contains(event.target)) {

            let EStateChange = { ...this.state.EquipmentDropDownStyles };
            EStateChange.display = "none";
            this.setState({ EquipmentDropDownStyles: EStateChange });
        }
        if (this.spaceWrapperRef && !this.spaceWrapperRef.contains(event.target)) {

            let SStateChange = { ...this.state.SpacesDropDownStyles };
            SStateChange.display = "none";
            this.setState({ SpacesDropDownStyles: SStateChange });
        }
    }

    preventScrollPropagation(event){
        if(this.wrapperRef && this.wrapperRef.contains(event.target)){         //Tenant Dropdown
            var scrollDown = event.wheelDelta < 0;
            if(scrollDown){
                var isAtBottom = this.wrapperRef.scrollTop + this.wrapperRef.clientHeight == this.wrapperRef.scrollHeight;
                if(isAtBottom){
                    event.preventDefault();
                }
            }
            else{
                var isAtTop = this.wrapperRef.scrollTop === 0;
                if(isAtTop){
                    event.preventDefault();
                }
            }
        }
        if(this.equipWrapperRef && this.equipWrapperRef.contains(event.target)){    //Equipment Dropdown
            var scrollDown = event.wheelDelta < 0;
            if(scrollDown){
                var isAtBottom = this.equipWrapperRef.scrollTop + this.equipWrapperRef.clientHeight == this.equipWrapperRef.scrollHeight;
                if(isAtBottom){
                    event.preventDefault();
                }
            }
            else{
                var isAtTop = this.equipWrapperRef.scrollTop === 0;
                if(isAtTop){
                    event.preventDefault();
                }
            }
        }
    }

    componentWillMount() {
        this.props.makeGetCall();
        this.props.GetWorkOrderBuildings();
        this.props.GetWorkOrderBuildingsEquipments(0);
        this.props.GetWorkOrderEquipments();
        this.props.GetCustomFields();
    }

    OnSort(values) {
        if(values !== undefined && values !== null && values !== "--"){
        const sorted_data = values.sort((a, b) => {
            let nameA, nameB;
            nameA = a.orderId;
            nameB = b.orderId;
            return (nameA - nameB);
        });
        return sorted_data;
    }
    }

    ComputeStyle() {
        var offset = ReactDOM.findDOMNode(this.refs.tenants_in_Select_input).getBoundingClientRect();
        let StateChange = { ...this.state.TenantDropDownStyles };
        StateChange.display = "block";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left = parseInt(offset.left);
        this.setState({ TenantDropDownStyles: StateChange });
    }

    ComputeEquipmentStyle() {
        var offset = ReactDOM.findDOMNode(this.refs.equipments_in_Select_input).getBoundingClientRect();
        let StateChange = { ...this.state.EquipmentDropDownStyles };
        StateChange.display = "block";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left = parseInt(offset.left);
        this.setState({ EquipmentDropDownStyles: StateChange });
    }

    ComputeSpaceStyle() {
        var offset = ReactDOM.findDOMNode(this.refs.Spaces_in_Select_input).getBoundingClientRect();
        let StateChange = { ...this.state.SpacesDropDownStyles };
        StateChange.display = "block";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left = parseInt(offset.left);
        this.setState({ SpacesDropDownStyles: StateChange });
    }

    LoadBuildingEquipment() {
        var selectedOption = this.refs.buildings_in_Select_input.options.selectedIndex;
        var selectedSiteId = this.refs.buildings_in_Select_input.options[selectedOption].id;

        var actualSiteId = 0;
        if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 &&
            selectedSiteId > 0) {
            var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == selectedSiteId);
            if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                actualSiteId = l_MappedSite[0].siteId;
            }
        }

        var l_SelectedBuilding = this.props.getBuildingEquipments.filter(el => el.siteId == actualSiteId);
        var l_Equipmentdata = []

        if (l_SelectedBuilding !== undefined && l_SelectedBuilding !== null && l_SelectedBuilding.length > 0) {
            var Equiplineitem = '';
            l_SelectedBuilding.forEach(building => {
                if (building.equipment !== undefined && building.equipment !== null && building.equipment.length > 0) {
                    let siteName = building.siteName;
                    building.equipment.forEach(element => {
                        Equiplineitem = {
                            "Id": element.objectId,
                            "Name": element.objectName,
                            "Location": siteName,
                            "SubId": 0,
                        }
                        l_Equipmentdata.push(Equiplineitem);
                    });
                }
            });
        };

        var l_SelectedBuildingEquipment = this.props.getEquipments.filter(el => el.siteId == selectedSiteId)
        if (l_SelectedBuildingEquipment !== undefined && l_SelectedBuildingEquipment !== null && l_SelectedBuildingEquipment.length > 0) {
            var Equiplineitem = '';
            l_SelectedBuildingEquipment.forEach(Equipment => {
                Equiplineitem = {
                    "Id": Equipment.id,
                    "Name": Equipment.name,
                    "Location": Equipment.buildingName,
                    "SubId": 1,
                }
                l_Equipmentdata.push(Equiplineitem);
            });
        }

        this.setState({
            BuildingId: this.refs.buildings_in_Select_input.options[selectedOption].id,
            BuildingName: this.refs.buildings_in_Select_input.options[selectedOption].value,
            EquipmentId: 0,
            EquipmentName: '',
            EquipmentData: l_Equipmentdata
        });
    }

    LoadData() {
        var SelectedBuildingIds = [];
        var l_Spacestdata = [];
        var SelectedItems = this.props.getTenantAssociations;

        SelectedItems.forEach(element => {
            SelectedBuildingIds.push(element.buildingID);
        });
        SelectedBuildingIds = SelectedBuildingIds.filter((val, id, array) => array.indexOf(val) == id);

        if (SelectedBuildingIds.length) {
            for (var i = 0; i < SelectedBuildingIds.length; i++) {
                var LineItem = this.FormFloorSpaceData(SelectedBuildingIds[i]);
                if (LineItem !== undefined && LineItem.length) {
                    for (var j = 0; j < LineItem.length; j++)
                        l_Spacestdata.push(LineItem[j]);
                }
            }
        }
        return l_Spacestdata;
    }

    FormFloorSpaceData(selectedSiteId) {
        var FloorCollection = [], SpaceCollection = [], l_Spacestdata = [];
        var SelectedItems = this.props.getTenantAssociations.filter(el => el.buildingID == selectedSiteId);

        if (SelectedItems !== undefined && SelectedItems.length) {
            var SelectedFloorIds = [], SelectedSpaceIds = [];
            SelectedItems.forEach(element => {
                if (element.floorID !== 0) {
                    SelectedFloorIds.push(element.floorID);
                }
                else {
                    SelectedSpaceIds.push(element.spaceID);
                }
            });

            if (SelectedFloorIds.length) {
                SelectedFloorIds = SelectedFloorIds.filter((val, id, array) => array.indexOf(val) == id);
                for (var i = 0; i < SelectedFloorIds.length; i++) {
                    var FilterData = SelectedItems.filter(x => x.floorID == SelectedFloorIds[i]);
                    if (FilterData !== undefined && FilterData.length) {
                        var SpaceInputCollection = [];
                        for (var j = 0; j < FilterData.length; j++) {
                            if (FilterData[j].spaceID !== 0)
                                SpaceInputCollection[j] = { 'id': FilterData[j].spaceID, 'name': FilterData[j].spaceName };
                        }
                        FloorCollection[i] = { 'id': FilterData[0].floorID, 'name': FilterData[0].floorName, spaces: SpaceInputCollection };
                    }
                }
            }
            if (SelectedSpaceIds !== undefined && SelectedSpaceIds !== null && SelectedSpaceIds.length) {
                for (var i = 0; i < SelectedSpaceIds.length; i++) {
                    var FilterData = SelectedItems.filter(x => x.spaceID == SelectedSpaceIds[i]);
                    SpaceCollection[i] = { 'id': FilterData[0].spaceID, 'name': FilterData[0].spaceName };
                }
            }
        }
        l_Spacestdata = this.FormFinalFloorSpaceData(FloorCollection, SpaceCollection, selectedSiteId);
        return l_Spacestdata;
    }

    FormFinalFloorSpaceData(FloorCollection, SpaceCollection, SiteId) {
        var l_Spacestdata = [], Spacelineitem = '';
        FloorCollection.forEach(element => {
            var l_FloorName = element.name;
            var l_FloorId = element.id;

            if (element.spaces.length > 0) {
                element.spaces.forEach(el => {
                    Spacelineitem = {
                        "Id": el.id,
                        "Name": el.name,
                        "Location": l_FloorName,
                        "SubId": l_FloorId,
                        "BuildingId": SiteId
                    }
                    l_Spacestdata.push(Spacelineitem);
                });
            }
            else {
                Spacelineitem = {
                    "Id": element.id,
                    "Name": element.name,
                    "Location": "",
                    "SubId": "",
                    "BuildingId": SiteId
                }
                l_Spacestdata.push(Spacelineitem);
            }
        });

        SpaceCollection.forEach(element => {
            Spacelineitem = {
                "Id": element.id,
                "Name": element.name,
                "Location": "",
                "SubId": 0,
                "BuildingId": SiteId
            }
            l_Spacestdata.push(Spacelineitem);
        });
        return l_Spacestdata;
    }

    LoadBuildingFloors() {
        var selectedOption = this.refs.buildings_in_Select_input.options.selectedIndex;
        var selectedSiteId = this.refs.buildings_in_Select_input.options[selectedOption].id;

        this.setState({
            BuildingId: this.refs.buildings_in_Select_input.options[selectedOption].id,
            BuildingName: this.refs.buildings_in_Select_input.options[selectedOption].value,
            FloorId: 0,
            SuiteId: 0,
            RoomId: 0,
            RoomName: '',
            EquipmentId: 0,
            TenantId: 0,
            TenantName: '',
            EquipmentName: '',
        });
        this.LoadBuildingEquipment();
        if(selectedSiteId !== '0')
            this.refs.buildings_in_Select_input.style.color = '#000000';
        else
            this.refs.buildings_in_Select_input.style.color = '#999999';
    }

    getUnique(arr, comp) {

        const unique = arr
            .map(e => e[comp])

            // store the keys of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the dead keys & store unique objects
            .filter(e => arr[e]).map(e => arr[e]);

        return unique;
    }

    setTenant(id, name, location, subId) {
        let StateChange = { ...this.state.TenantDropDownStyles };
        StateChange.display = "none";

        this.setState({
            TenantId: id,
            TenantName: name,
            FloorId: 0,
            SuiteId: 0,
            RoomId: 0,
            TenantDropDownStyles: StateChange,
            TenantLocation: location
        });
        // this.refs.buildings_in_Select_input.style.color = 'gray';
        var selectedOption = this.refs.buildings_in_Select_input.options.selectedIndex;
        var selectedSiteId = this.refs.buildings_in_Select_input.options[selectedOption].id;
        if(selectedSiteId !== '0')
            this.refs.buildings_in_Select_input.style.color = '#000000';
        else
            this.refs.buildings_in_Select_input.style.color = '#999999';
    }

    SelectUrgency() {
        var selectedOption = this.refs.urgencys_in_Select_input.options.selectedIndex;
        var selectedUrgencyId = this.refs.urgencys_in_Select_input.options[selectedOption].id;
        this.setState({ UrgencyId: selectedUrgencyId });
        if(selectedUrgencyId !== '0')
            this.refs.urgencys_in_Select_input.style.color = '#000000';
        else
            this.refs.urgencys_in_Select_input.style.color = '#999999';
    }

    SelectProblem() {
        var selectedOption = this.refs.problems_in_Select_input.options.selectedIndex;
        var selectedProblemId = this.refs.problems_in_Select_input.options[selectedOption].id;
        this.setState({ ProblemId: selectedProblemId });
        if(selectedProblemId !== '0')
            this.refs.problems_in_Select_input.style.color = '#000000';
        else
            this.refs.problems_in_Select_input.style.color = '#999999';
    }


    OnUserChange() {
        var selectedOption = this.refs.user_in_Select_input.options.selectedIndex;
        var selectedUserId = this.refs.user_in_Select_input.options[selectedOption].id;
        var MailAddress = "";
        if(selectedUserId !== '0' && this.props.getTechnicianList !== undefined && this.props.getTechnicianList.length)
            MailAddress = this.props.getTechnicianList.filter(x => x.technicianID == selectedUserId)[0].emailAddress;
        this.setState({ UserId: selectedUserId, HasEmailAddress: MailAddress !== "" ? true : false }); 
        this.refs.ref_Assigned_User.checked = (MailAddress !== "" && this.props.getMailSetting) ? true : false;
        if(selectedUserId !== '0')
            {
                this.refs.user_in_Select_input.style.color = '#000000';
                this.setState({SelectedNotifyOthersIds: this.state.SelectedNotifyOthersIds.filter(e => e !== Number(selectedUserId))})
            }
        else
                this.refs.user_in_Select_input.style.color = '#999999';
    }

    onNotifyOthersSelect(args){
        var l_SelectedNotifyOthersIds = (this.state.SelectedNotifyOthersIds !== undefined && this.state.SelectedNotifyOthersIds.length) ? this.state.SelectedNotifyOthersIds : [];
        l_SelectedNotifyOthersIds.push(args.itemData.id);
        this.setState({SelectedNotifyOthersIds:  l_SelectedNotifyOthersIds})
    }

    onNotifyOthersRemove(args){
        var l_SelectedNotifyOthersIds = this.state.SelectedNotifyOthersIds;
        var FilteredData = l_SelectedNotifyOthersIds.filter(x => x !== args.itemData.id);
        this.setState({SelectedNotifyOthersIds: FilteredData });
    }

    OnStatusChange() {
        var selectedOption = this.refs.status_in_Select_input.options.selectedIndex;
        this.setState({
            StatusId: this.refs.status_in_Select_input.options[selectedOption].id,
        });
    }

    setEquipment(id, name, location, isNonDiscovered) {
        var logicalBuildingId;
        if(this.state.BuildingId === 0){
            var FilterValue = this.props.getBuildingEquipments.filter(e => e.siteName === location);
            if(FilterValue[0] !== undefined && FilterValue[0] !== null)
                logicalBuildingId = this.props.getBuildingEquipments.filter(e => e.siteName === location)[0].siteId;
            else
                logicalBuildingId = 0;
        }else{
            logicalBuildingId = 0;
        }            
        let StateChange = { ...this.state.EquipmentDropDownStyles };
        StateChange.display = "none";

        if (id === '') {
            this.setState({
                EquipmentId: 0,
                EquipmentName: name,
                IsNonDiscoveredEquipment: isNonDiscovered,
                EquipmentDropDownStyles: StateChange,
                LogicalBuildingId: 0,
                EquipmentLocation: location
            });
        } else {
            this.setState({
                EquipmentId: id,
                EquipmentName: name,
                IsNonDiscoveredEquipment: isNonDiscovered,
                EquipmentDropDownStyles: StateChange,
                LogicalBuildingId: logicalBuildingId,
                EquipmentLocation: location
            });
        }
    }

    setSpace(id, name, subId, buildingId) {
        let StateChange = { ...this.state.EquipmentDropDownStyles };
        StateChange.display = "none";

        if (subId === '') {
            this.setState({
                RoomId: 0,
                RoomName: name,
                FloorId: id,
                BuildingId: buildingId,
                SpacesDropDownStyles: StateChange
            });
        } else {
            this.setState({
                RoomId: id,
                RoomName: name,
                FloorId: subId,
                BuildingId: buildingId,
                SpacesDropDownStyles: StateChange
            });
        }
    }

    _handleAttachment(e) {
        e.preventDefault();

        this.setState({
            displayImageError:false,
            errorImageName:null,
            errorImageText:" file size limit exceeded.",
        });
        var fileTypes = ['doc','docx','jpg','jpeg','png','pdf'];

        if (e.target.files && e.target.files[0]) {
            var extension = e.target.files[0].name.split('.').pop().toLowerCase(), //file extension from input file
            fileTypeSuccess = fileTypes.indexOf(extension) > -1;  //is extension in acceptable types
            var fileSize = document.getElementById('myfile').files[0].size; //Checking for file size

            if (fileTypeSuccess && fileSize <= 25000000 ) {
                let reader = new FileReader();
                let file = e.target.files[0];
                reader.onloadend = () => {
                    const data = new FormData();
                    data.append('file', file);
                    const l_Request = this.props.SaveAttachmentToFolder(data, 0);
                    l_Request.then((result) => {
                        if (this.props.getUniqueAttachmentName !== undefined && this.props.getUniqueAttachmentName !== null && this.props.getUniqueAttachmentName !== []) {
                            this.setState({ image_Array: [...this.state.image_Array, { 'id': 0, 'name': file.name, 'fileName': this.props.getUniqueAttachmentName.FileName }] });
                        }
                    });
                }
                reader.readAsDataURL(file)
                e.target.value = null;
            } else if(fileSize >= 25000000) { 
                this.setState({
                    displayImageError:true,
                    errorImageName:e.target.files[0].name,
                    errorImageText:" file size limit exceeded.",
                })
            }
            else  { 
                this.setState({
                    displayImageError:true,
                    errorImageName:e.target.files[0].name,
                    errorImageText:" file type not supported.",
                });
            }
        }
    }

    DeleteAttachment(element) {
        let lineitem = {
            "AttachmentId": 0,
            "FileName": element,
        }
        this.props.DeleteAttachment(lineitem);

        this.setState({
            image_Array: this.state.image_Array.filter(el => el.fileName != element)
        });
    }

    OnCancel() {
        
        if(this.props.ForEquipment !== undefined && this.props.ForEquipment !== null && this.props.ForEquipment == true)
        {            
            var l_Cancel = this.props.OnPopupCancel("0");
            l_Cancel(0);
            //this.props.closeModalPopUp("close");
        }
        if(this.props.ForAlarm != true)
            this.setState({ redirectHome: true });        
    }

    ClearCustomErrors(){
        this.state.error.customname = false;
        var lCustomColtxts = document.getElementsByClassName("customfieldsColtxt");
        if(lCustomColtxts !== undefined && lCustomColtxts !== null && lCustomColtxts.length){
            for(var i=0; i<lCustomColtxts.length; i++){
                var lChildrens = lCustomColtxts[i].childNodes;
                lChildrens[0].classList.remove('errortext');
                lChildrens[2].style.width = "100%";
                lChildrens[2].classList.remove('errorhighlight');
                lChildrens[3].setAttribute('hidden',true);
            }
        }
        var lCustomColddls = document.getElementsByClassName("customfieldsColddl");
        if(lCustomColddls !== undefined && lCustomColddls !== null && lCustomColddls.length){
            for(var i=0; i<lCustomColddls.length; i++){
                var lChildrens = lCustomColddls[i].childNodes;
                lChildrens[0].classList.remove('errortext');
                lChildrens[2].classList.remove('errorhighlight');
                lChildrens[3].setAttribute('hidden',true);
            }
        }
    }

    OnSaveWorkOrder() {
        this.ClearCustomErrors();
        this.setState({ IsClickSave: true });
        let preferredfields = this.props.getWorkorderPreferences;
        //var problemCheck = this.props.getWorkorderPreferences.filter(x => x.field == this.props.getLabels['WorkOrderDetails.Problem.Text'])[0].display;
        //var urgencyCheck = this.props.getWorkorderPreferences.filter(x => x.field == this.props.getLabels['WorkOrderDetails.Urgency.Text'])[0].display;
        var tenant = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Tenant")[0] : "";
        var building = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Building")[0] : "";
        var floor = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Floor")[0] : "";
        var space = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Space")[0] : "";
        var problem = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Problem")[0] : "";
        var description = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Description")[0] : "";
        var urgency = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Urgency")[0] : "";
        var equipment = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Equipment")[0] : "";
        var assignedto = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Assigned To")[0] : "";
        var status = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Status")[0] : "";
        var notifyOthers = preferredfields !== undefined ? preferredfields.filter(x => x.field === "Notify Others")[0] : "";
        var dueDate = preferredfields !== undefined ? preferredfields.filter(x => x.field === "DueDate")[0] : "";

        var selectedOption, selectedSiteId = 0;
        // var statusValue = Math.min(...status.value.map(x => parseInt(x.orderId)));
        if (building.required) {
            selectedOption = this.refs.buildings_in_Select_input.options.selectedIndex;
            selectedSiteId = this.refs.buildings_in_Select_input.options[selectedOption].id;
        }

        var IsChecked_email = false;//added a condition to check email sending notification

        (!tenant.required || (tenant.required == true && this.state.TenantId != '')) ? this.state.error.tenant = false : this.state.error.tenant = true;
        (!building.required || (building.required == true && this.state.BuildingId > 0 && selectedSiteId > 0)) ? this.state.error.building = false : this.state.error.building = true;
        (!floor.required || (floor.required == true && (this.state.RoomId != "" || this.state.FloorId != ""))) ? this.state.error.floor = false : this.state.error.floor = true;
        (!space.required || (space.required == true && (this.state.RoomId != "" || this.state.FloorId != ""))) ? this.state.error.space = false : this.state.error.space = true;
        (!problem.required || (problem.required == true && this.state.ProblemId > 0)) ? this.state.error.problem = false : this.state.error.problem = true;
        (!description.required || (description.required == true && this.refs.description.value != "")) ? this.state.error.description = false : this.state.error.description = true;
        (!urgency.required || (urgency.required == true && this.state.UrgencyId > 0)) ? this.state.error.urgency = false : this.state.error.urgency = true;
        (!equipment.required || (equipment.required == true && this.state.EquipmentId > 0)) ? this.state.error.equip = false : this.state.error.equip = true;
        (!assignedto.required || (assignedto.required == true && this.state.UserId > 0)) ? this.state.error.assignto = false : this.state.error.assignto = true;
        (!status.required || (status.required == true && this.state.StatusId > 0)) ? this.state.error.status = false : this.state.error.status = true;
        (!notifyOthers.required || (notifyOthers.required == true && this.state.SelectedNotifyOthersIds.length > 0)) ? this.state.error.notifyOthers = false : this.state.error.notifyOthers = true;
        (!dueDate.required || (dueDate.required == true && this.state.dueDate != null)) ? this.state.error.dueDate = false : this.state.error.dueDate = true;
        // if((!tenant.required || (tenant.required == true && this.state.TenantId != '')) && (!building.required || (building.required == true && this.state.BuildingId > 0 && selectedSiteId > 0)) && (!space.required || (space.required == true && this.state.RoomId != "")) && (!problem.required ||(problem.required == true && this.state.ProblemId >0 )) 
        // && (!description.required || (description.required == true && this.refs.description.value != "")) && (!urgency.required || (urgency.required == true && this.state.UrgencyId > 0)) && (!equipment.required || (equipment.required == true && this.state.EquipmentId > 0)) && (!assignedto.required || (assignedto.required == true && this.state.UserId > 0)))
        //custom fields validations
        var lCustomFieldCol = [];
        var lCustomColtxts = document.getElementsByClassName("customfieldsColtxt");
        if(lCustomColtxts !== undefined && lCustomColtxts !== null && lCustomColtxts.length){
            for(var i=0; i<lCustomColtxts.length; i++){
                var lChildrens = lCustomColtxts[i].childNodes;
                var CustomTxtBoxValue = lChildrens[2].value;
                CustomTxtBoxValue = CustomTxtBoxValue.trim();
                var CustomTxtBoxAttr = lChildrens[2].getAttribute("data-key");
                if(CustomTxtBoxAttr.split('~')[1] === "true" && !!CustomTxtBoxValue === false){
                    lChildrens[0].classList.add('errortext');
                    lChildrens[2].style.width = "81%";
                    lChildrens[2].classList.add('errorhighlight');
                    lChildrens[3].removeAttribute('hidden');
                    this.state.error.customname = true;
                }
                lCustomFieldCol.push({
                    "CustomFieldID" : Number(CustomTxtBoxAttr.split('~')[0]),
                    "CustomFieldValueID" : 0,
                    "CustomFieldTextValue" : CustomTxtBoxValue
                });
            }
        }
        var lCustomColddls = document.getElementsByClassName("customfieldsColddl");
        if(lCustomColddls !== undefined && lCustomColddls !== null && lCustomColddls.length){
            for(var i=0; i<lCustomColddls.length; i++){
                var lChildrens = lCustomColddls[i].childNodes;
                var CustomddlIndex = lChildrens[2].options.selectedIndex;
                var CustomddlValue = lChildrens[2].options[CustomddlIndex].id;
                var CustomddlAttr = lChildrens[2].getAttribute("data-key");
                if(CustomddlAttr.split('~')[1] === "true" && CustomddlValue === "0"){
                    lChildrens[0].classList.add('errortext');
                    lChildrens[2].classList.add('errorhighlight');
                    lChildrens[3].removeAttribute('hidden');
                    this.state.error.customname = true;
                }
                lCustomFieldCol.push({
                    "CustomFieldID" : Number(CustomddlAttr.split('~')[0]),
                    "CustomFieldValueID" : Number(CustomddlValue),
                    "CustomFieldTextValue" : ""
                });
            }
        }

        if (!this.state.error.tenant && !this.state.error.building && !this.state.error.floor && !this.state.error.space && !this.state.error.assignto && !this.state.error.problem && !this.state.error.description &&
            !this.state.error.urgency && !this.state.error.equip && !this.state.error.status && !this.state.error.customname && !this.state.error.notifyOthers && !this.state.error.dueDate) {
            var Attachments = [], AttachmentItems = '';
            if (this.state.image_Array.length) {
                this.state.image_Array.forEach(el => {
                    AttachmentItems = {
                        "AttachmentName": el.name,
                        "FileName": el.fileName
                    }
                    Attachments.push(AttachmentItems);
                });
            }

            if(this.refs.ref_Assigned_User != undefined || this.refs.ref_Assigned_User != null)
                IsChecked_email = this.refs.ref_Assigned_User.checked;
        
            let lineitem = {
                // "Status": status.value.filter(x => x.orderId == statusValue)[0].key,
                "Status": this.state.StatusId,
                "Description": description.display ? this.state.Description : "",
                //"Description": description.display ? this.refs.description.value : "",
                "AssignedUserID": this.state.UserId,
                "DueDate": this.state.dueDate !== null ? this.state.dueDate : '1753-01-01T00:00:00',
                "Urgency": parseInt(this.state.UrgencyId),
                "IsMailRequired" : IsChecked_email,
                "CreatedByUserID": 1,
                "WorkOrderDetail": {
                    "TenantID": (this.state.TenantId != '') ? this.state.TenantId : 0,
                    "TenantName": (this.state.TenantId != '') ? this.state.TenantName : 'NOT ASSIGNED',
                    "SiteID": this.state.BuildingId,
                    "SiteName": (this.state.BuildingId != '0' && this.state.BuildingId != '') ? this.state.BuildingName : 'NOT ASSIGNED',
                    "FloorID": this.state.FloorId !== "" ? this.state.FloorId : 0,
                    "SuiteID": this.state.SuiteId != '' ? this.state.SuiteId : 0,
                    "SpaceID": this.state.RoomId != '' ? this.state.RoomId : 0,
                    "EquipmentID": this.state.EquipmentId !== "" ? this.state.EquipmentId : 0,
                    "EquipmentName":(this.state.EquipmentName != '')? this.state.EquipmentName : 'NOT ASSIGNED',
                    "IsNonDiscoveredEquipment": this.state.IsNonDiscoveredEquipment,
                    "ProblemID": this.state.ProblemId,
                    "OtherProblem": '',
                    "LogicalBuildingID": this.state.LogicalBuildingId
                },
                "WorkOrderAttachment": (this.state.image_Array.length > 0) ? Attachments : null,
                "WorkOrderCustomFields": lCustomFieldCol,
                "NotifyUserIDs": this.state.SelectedNotifyOthersIds,
            }
            setAmplitudeEvent("Create Work Order",{"Notify Others":this.state.SelectedNotifyOthersIds.length,"Page":'Admin Screen'});
            const l_Request = this.props.SaveWorkOrder(lineitem, (this.props.AlarmInfo != undefined && this.props.AlarmInfo.length > 0) ? this.props.AlarmInfo[0].EquipmentId : 0);
            l_Request.then((result) => {
                if(this.props.ForAlarm !== undefined && this.props.ForAlarm !== null && this.props.ForAlarm == true)
                {
                    // do nothing
                }
                else
                    this.setState({ redirectHome: true, IsError: false });
            });
            if(this.props.ForEquipment !== undefined && this.props.ForEquipment !== null && this.props.ForEquipment == true)
            {               
                var l_Cancel = this.props.OnPopupCancel;
                l_Cancel(1);                
            }
        }
        else {
            this.setState({ IsError: true, IsClickSave: false });
        }
    }

    FormCustomFields(IsEquipment){
        const l_rows = [];
        var Default_drop_down_value = <option value="" id="0" selected>{this.props.getLabels['WorkOrders.DropDown.Default.Text']}</option>
        if(this.props.getCustomFields !== undefined && this.props.getCustomFields !== null && this.props.getCustomFields.length){
            var lCustomFields = this.props.getCustomFields.filter(el => el.display === true);
            if(lCustomFields !== undefined && lCustomFields !== null && lCustomFields.length){
                var l_CustomFields = this.OnSort(lCustomFields);
                const l_lstCustomFields = l_CustomFields.map((item) => {
                    if(item.fieldType === 0){
                        return <Col className="customfieldsColtxt" key={item.fieldId} sm={{ size: IsEquipment ? 4 : 2 }}>
                                <Label className="workorderlbl">{(item.required) ? item.fieldLabel + "*" : item.fieldLabel}</Label>
                                <br />
                                <input type="text" maxLength={50}  data-key={item.fieldId + '~' + item.required} style={{width: '100%'}} className="pm_textbox customtxtbox" />
                                <span hidden={true}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></span>
                            </Col>
                    }else{
                        var CustomValue_in_Select_input;
                        if (item.value !== undefined && item.value !== null && item.value.length > 0) {
                            var custom_values = this.OnSort(item.value);
                            CustomValue_in_Select_input = custom_values.map(el => (
                                <option id={el.key}>{el.value}</option>
                            ));
                        }
                        return <Col className="customfieldsColddl" key={item.fieldId} sm={{ size: IsEquipment ? 4 : 2 }}>
                                <Label className="workorderlbl">{(item.required) ? item.fieldLabel + "*" : item.fieldLabel}</Label><br />
                                <select data-key={item.fieldId + '~' + item.required} id={"ddl_"+item.fieldId} className="minimal workorderedit-dropdown" style={{width: '100%', "color" : "gray"}} onChange={() => { this.SelectCustomValues("ddl_"+item.fieldId) }}>
                                    {Default_drop_down_value}
                                    {CustomValue_in_Select_input}
                                </select>
                                <span hidden={true}><Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>Please make a selection</b></Label></span>
                            </Col>
                    }
                });
                
                // Push a new row for every set of three fields
                for (let row = 0; row < Math.ceil(l_CustomFields.length / 3); row++) {
                    l_rows.push(<div key={"div_"+row} className="row form-group" style={{'margin-left':'0px'}}>
                        {l_lstCustomFields.slice((row * 3), ((row + 1) * 3))}
                    </div>);
                };
            }
        }
        return l_rows;
    }

    SelectCustomValues(ele){
        var selectedOption = document.getElementById(ele).options.selectedIndex;
        var selectedCustomValueId = document.getElementById(ele).options[selectedOption].id;
        if(selectedCustomValueId !== '0')
            document.getElementById(ele).style.color = '#000000';
        else
            document.getElementById(ele).style.color = '#999999';
    }

    handleChange(date) {
        if(date !== null){
            var myDate = new Date(date);
            var fDate;
            let utcOffsetMinute = moment().utcOffset();
         
            if (utcOffsetMinute >= 0) {
                fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
            }
            else {
                fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
            }
            this.setState({
                dueDate: new Date(fDate)
            });
        }else{
            this.setState({
                dueDate: null
            });
        }
        
    }

    render(getWorkorderPreferences) {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        let label = this.props.getLabels;
        let PreferedDateFormat = this.props.UserPreference_response;
        //let preferredfields = [...this.props.getWorkorderPreferences];
        let preferredfields = JSON.parse(decodeURIComponent(encodeURIComponent(JSON.stringify( this.props.getWorkorderPreferences))));
        let UserFormat = Conversions.UserPreferenceDateFormat_DatePicker(PreferedDateFormat);
        
        let HasMailSetting = this.props.getMailSetting;
        let error_record = null;
        let BuildingsList;

        var tenant = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Tenant" && x.display === true) : "";
        var building = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Building" && x.display === true) : "";
        var floor = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Floor" && x.display === true) : "";
        var space = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Space" && x.display === true) : "";
        var problem = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Problem" && x.display === true) : "";
        var description = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Description" && x.display === true) : "";
        var urgency = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Urgency" && x.display === true) : "";
        var equipment = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Equipment" && x.display === true) : "";
        var assignedto = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : "";
        var status = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Status" && x.display === true) : "";
        var notifyOthers = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Notify Others" && x.display === true) : "";
        var dueDate = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "DueDate" && x.display === true) : "";

        var errormsg;
        var selecterrortext;
        if (this.state.redirectHome && !IsEquipment) {
            return <Redirect to={"/ManageWorkOrder"} />
        } else if(this.state.redirectHome && IsEquipment){
            return <Redirect to ={"/EquipmentWrapper"}/>
        }

        if (this.state.IsError) {
            // errormsg = <p  className="error_msg">
            //                 <img src={ErrorGif} alt="Trane Logo" /> 
            //                 {label['ValidationError.Text']}
            //                 </p> 
            errormsg = <p style={ErrorPadding} >
                <Icon name='exclamation triangle' style={ErrorSign} />
                <b>Please correct all errors before continuing.</b>
            </p>
        }
        selecterrortext = <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>Please make a selection</b></Label>
        if (this.state.BuildingId > 0) {
            var l_data = [], lineitem = '';
            this.props.getTenantList.forEach(element => {
                if(element.buildings != null) {                   
                if (element.buildings.filter(x => x.buildingId == this.state.BuildingId).length > 0) {
                    lineitem = {
                        "Id": element.tenantId,
                        "Name": element.tenantName, //this.FormValidDate(this.state.start_date),
                        "Location": element.address, //this.FormValidDate(this.state.end_date),
                        "SubId": 0,
                    }
                    l_data.push(lineitem);
                }
            }});
            this.state.TenantData = l_data;
        }
        else {
            if (this.props.getTenantList != undefined) {
                var l_data = [], lineitem = '';
                this.props.getTenantList.forEach(element => {
                    lineitem = {
                        "Id": element.tenantId,
                        "Name": element.tenantName, //this.FormValidDate(this.state.start_date),
                        "Location": element.address, //this.FormValidDate(this.state.end_date),
                        "SubId": 0,
                    }
                    l_data.push(lineitem);
                });

                this.state.TenantData = l_data;
            }
        }

        //var l_Buildings = this.props.getWorkOrderBuildings.filter(x => x.siteId == (this.props.AlarmInfo != undefined && this.props.AlarmInfo.length > 0) ? this.props.AlarmInfo[0].SiteId : -1).length > 0 ? this.props.getWorkOrderBuildings.filter(x => x.siteId == this.props.AlarmInfo[0].SiteId)[0].id : 0;
        var l_Buildings = (this.props.AlarmInfo != undefined && this.props.AlarmInfo.length > 0) ? this.props.AlarmInfo[0].SiteId : 0;
        if (this.props.getBuildingEquipments != undefined && this.props.getBuildingEquipments.length > 0 &&
            ((this.state.BuildingId === undefined || this.state.BuildingId <= 0) || (this.state.BuildingId == l_Buildings)) && this.state.EquipmentData.length == 0) {
            var l_Equipmentdata = [], Equiplineitem = '';

            var l_getBuildingEquipments = (this.props.ForEquipment && this.state.BuildingId > 0) ? this.props.getBuildingEquipments.filter(x => x.siteId == this.props.AlarmInfo[0].SiteId) : this.props.getBuildingEquipments;
            l_getBuildingEquipments.forEach(building => {
                if (building.equipment !== undefined && building.equipment !== null && building.equipment.length > 0) {
                    let siteName = building.siteName;
                    building.equipment.forEach(element => {
                        Equiplineitem = {
                            "Id": element.objectId,
                            "Name": element.objectName,
                            "Location": siteName,
                            "SubId": 0,
                        }
                        l_Equipmentdata.push(Equiplineitem);
                    });
                }
            });

            var l_getEquipments = (this.props.ForEquipment && this.state.BuildingId > 0) ? this.props.getEquipments.filter(x => x.siteId == this.state.BuildingId) : this.props.getEquipments;
            if (l_getEquipments != undefined && l_getEquipments.length > 0) {
                l_getEquipments.forEach(NonDiscEquip => {
                    Equiplineitem = {
                        "Id": NonDiscEquip.id,
                        "Name": NonDiscEquip.name,
                        "Location": NonDiscEquip.buildingName,
                        "SubId": 1,
                    }
                    l_Equipmentdata.push(Equiplineitem);
                });
            }
            
            this.state.EquipmentData = l_Equipmentdata;
        }

        var Default_drop_down_value = <option value="" id="0" selected>{label['WorkOrders.DropDown.Default.Text']}</option>
        var Default_drop_down_value_Unselected = <option value="" id="0" >{label['WorkOrders.DropDown.Default.Text']}</option>
        var buildings_in_Select_input = null;
        var Attachment_Table = "";
        var tenants_in_Select_input = null; //eslint-disable-line
        var problems_in_Select_input = null;
        var urgency_in_Select_input = null;        
        var equipments_in_Select_input = null; //eslint-disable-line
        var technicians_in_Select_input = null;
        var status_in_Select_input = null;
        var notifiers_in_Select_input = [];

        error_record = <tr>
                          <td width="100%"><Icon name='exclamation triangle'style={{marginRight:'1px',padding:'0px',color:'#D42D27'}}/>{" An error has occurred. "}{this.state.errorImageName}{this.state.errorImageText}</td><td></td>
                       </tr>

    if (this.state.image_Array != null && this.state.image_Array.length > 0) {
            Attachment_Table = this.state.image_Array.map(el => (
        <tr>
            <td className="workorderlbl" style={{ "width": "90%", "word-wrap": "break-word" }}>{el.name}</td>

            <td width="10%"><img src={DeleteIcon} className="Ensemble_Icon link_cursor" style={{ valign: 'bottom', width: '15px', height: '14px' }} onClick={() => { this.DeleteAttachment(el.fileName) }} /></td>
        </tr>
           ));
        }
       else {
    Attachment_Table = <tr><td className="workorderlbl-noentry">{"No attachments"}</td><td>{" "}</td></tr>
         }

        if (this.props.getTechnicianList != undefined && this.props.getTechnicianList != null) {
            let lSortedTechnicianlst = this.props.getTechnicianList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()));
            technicians_in_Select_input = lSortedTechnicianlst.map(el => (
                <option id={el.technicianID}>{el.name}</option>
            ));
            lSortedTechnicianlst.forEach(el => {
                if(el.technicianID !== Number(this.state.UserId) && el.emailAddress !== ""){
                    notifiers_in_Select_input.push({ "id": el.technicianID, "value" : el.name })
                }
            });
        }

        if (this.props.getWorkOrderBuildings != null && this.props.getWorkOrderBuildings != undefined && this.props.getWorkOrderBuildings.length > 0)
            BuildingsList = this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false).sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()));
        // if (this.state.TenantId !== '' && this.state.AssociateBuildings !== undefined && this.state.AssociateBuildings.length) {
        //     buildings_in_Select_input = this.state.AssociateBuildings.map(el => (
        //         <option id={el.id}>{el.name}</option>
        //     ));
        // } else {
        if (BuildingsList != null && BuildingsList != undefined && BuildingsList.length > 0) {
            if (this.props.ForEquipment && this.state.BuildingId > 0) {
                buildings_in_Select_input = BuildingsList.map(el => (
                    <option id={el.id} selected={el.id == this.state.BuildingId} >{el.name}</option>
                ));
            }
            else {
                buildings_in_Select_input = BuildingsList.map(el => (
                    <option id={el.id} >{el.name}</option>
                ));
            }
        }
        //}

        if (this.state.EquipmentData != null) {
            equipments_in_Select_input = this.state.EquipmentData.map(el => (
                <option id={el.objectId} style={{ display: "none" }}>{el.objectName}</option>
            ));

        }

        var Problems = label['WorkOrders.Problem.Text'].split(',');
        if (problem.length > 0) {
            if (problem[0].value.length > 0) {
                var problem_values = this.OnSort(problem[0].value);
                problems_in_Select_input = problem_values.map(el => (
                    <option id={el.key}>{el.value}</option>
                ));
            }
            else {
                problems_in_Select_input = Problems.map(el => (
                    <option id={el}>{label['WorkOrders.Problem.' + el + '.Text']}</option>
                ));
            }
        }

        var Urgency = label['WorkOrders.Urgency.Text'].split(',');
        if (urgency.length > 0) {
            if (urgency[0].value.length > 0) {
                var urgency_values = this.OnSort(urgency[0].value);
                urgency_in_Select_input = urgency_values.map(el => (
                    <option id={el.key}>{el.value}</option>
                ));
            }
            else {
                urgency_in_Select_input = Urgency.map(el => (
                    <option id={el}>{label['WorkOrders.Urgency.' + el + '.Text']}</option>
                ));
            }
        }

        var Status = label['WorkOrders.Status.Text'].split(',');
        if (status.length > 0) {
            if (status[0].value.length > 0) {
                var status_values = this.OnSort(status[0].value);
                status_in_Select_input = status_values.map(el => (
                    <option id={el.key}>{el.value}</option>
                ));
            }
            else {
                status_in_Select_input = Status.map(el => (
                    <option id={el} value={el} >{label['WorkOrders.Status.' + el + '.Text']}</option>
                ));
            }
        }


        if (this.props.getTenantList != null) {
            tenants_in_Select_input = this.props.getTenantList.sort((a,b) => (a.tenantName.toLowerCase() > b.tenantName.toLowerCase()) - (a.tenantName.toLowerCase() < b.tenantName.toLowerCase())).map((el, i) => (
                <option id={el.tenantId} key={i} style={{ display: "none" }}>{el.tenantName}</option>
            ));
        }

        //Applying Custom Fields
        let lstCustomFields= this.FormCustomFields(IsEquipment);
        

        return (
            <div className={this.props.Premise ? "main_container" : "cloud_main_container"}>
                <Form>
                    <div className="border_container">&nbsp;
                    <FormGroup row style={{ "margin-bottom": "1px"}}>
                        <Col sm={{ size: 11 }} style={{'margin-left':'15px'}}>
                            <Label className='workordermainheaderlbl'>{label['WorkOrders.CreateWorkOrder.Text']}</Label>
                            {errormsg}
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ "margin-left":"0px" }}>
                        {
                            (status.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.status) ? classnames("errortext workorderlbl", "workorderlbl") : "workorderlbl"}>{(status[0].required) ? status[0].fieldLabel + "*" : status[0].fieldLabel}</Label><br />
                                    <select ref='status_in_Select_input' className={(this.state.error.status) ? classnames("errorhighlight", "minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"} style={{ width: '100%' }} onChange={this.OnStatusChange} >
                                        {status_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.status}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (assignedto.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.assignto) ? classnames("errortext workorderlbl", "workorderlbl") : "workorderlbl"}>{(assignedto[0].required) ? assignedto[0].fieldLabel + "*" : assignedto[0].fieldLabel}</Label><br />
                                    <select ref='user_in_Select_input' className={(this.state.error.assignto) ? classnames("errorhighlight minimal workorderedit-dropdown", "minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"} style={{ width: '100%', "color" : "gray" }} onChange={this.OnUserChange} >
                                        {Default_drop_down_value}
                                        {technicians_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.assignto}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (notifyOthers.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.notifyOthers) ? classnames("errortext workorderlbl", "workorderlbl") : "workorderlbl"}>{(notifyOthers[0].required) ? notifyOthers[0].fieldLabel + "*" : notifyOthers[0].fieldLabel}</Label><br />
                                    <MultiSelectComponent id="select_notifyothers" ref='notifyothers_in_Select_input' width='100%' cssClass={(this.state.error.notifyOthers) ? classnames("arrowdown-error multiselect-dropdown", "arrowdown multiselect-dropdown") : "arrowdown multiselect-dropdown"}
                                        dataSource={notifiers_in_Select_input}
                                        fields={this.dropdown_fields}
                                        mode="CheckBox"
                                        select={this.onNotifyOthersSelect.bind(this)}
                                        removed={this.onNotifyOthersRemove.bind(this)}
                                        value={this.state.SelectedNotifyOthersIds}
                                        showSelectAll={true} enableSelectionOrder={false}
                                        filterBarPlaceholder="Search" placeholder="Select" selectAllText="Select All" unSelectAllText="Clear All" >
                                        <Inject services={[CheckBoxSelection]} />
                                    </MultiSelectComponent>
                                    <span hidden={!this.state.error.notifyOthers}>{selecterrortext}</span>
                                </Col>:""
                        }
                        {
                            (urgency.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.urgency) ? "errortext workorderlbl" : "workorderlbl"} >{(urgency[0].required) ? urgency[0].fieldLabel + "*" : urgency[0].fieldLabel}</Label><br />
                                    <select ref='urgencys_in_Select_input' className={(this.state.error.urgency) ? "errorhighlight minimal workorderedit-dropdown" : "minimal workorderedit-dropdown"} style={{width: '100%', "color" : "gray"}} onChange={this.SelectUrgency}>
                                        {Default_drop_down_value}
                                        {urgency_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.urgency}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (dueDate.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.dueDate)? classnames("errortext","workorderlbl"):"workorderlbl"}>{(dueDate[0].required) ? dueDate[0].fieldLabel + "*" : dueDate[0].fieldLabel}</Label><br />
                                    <div className={(this.state.error.dueDate)? classnames("customDatePickerWidthError workorderheaderlbl") : "customDatePickerWidth workorderheaderlbl"}>
                                    <DatePicker
                                        customInput={<DatePickerCustom />}
                                        utcOffset={0}
                                        selected={this.state.dueDate} isClearable={false} 
                                        onChange={this.handleChange} showDisabledMonthNavigation
                                        dateFormat={UserFormat} />
                                </div>
                                <span hidden={!this.state.error.dueDate}>{selecterrortext}</span>
                                </Col> : ""
                        }
                    </FormGroup>
                    <hr style={{backgroundColor:'#666666','margin-right':'15px','margin-left':'15px', border:'none', height:'1px' }} />
                    <FormGroup row>
                        <Col sm={{ size: 2 }} style={{'margin-left':'15px'}}>
                            <Label className='workordermainheaderlbl'>{label['WorkOrderEdit.Details.Text'] !== undefined ? label['WorkOrderEdit.Details.Text'] : "Details"}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ "margin-left":"0px" }}>
                        {
                            (building.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.building) ? classnames("errortext workorderlbl", "workorderlbl") : "workorderlbl"}>{(building[0].required) ? building[0].fieldLabel + "*" : building[0].fieldLabel}</Label><br />
                                    <select ref='buildings_in_Select_input' selectedValue={this.state.BuildingName} className={(this.state.error.building) ? classnames("errorhighlight  minimal workorderedit-dropdown", "minimal workorderedit-dropdown") : "minimal workorderedit-dropdown"} style={{ width: '100%', "color" : (this.props.ForEquipment && this.state.BuildingId > 0) ? "black" : "gray" }} onChange={this.LoadBuildingFloors} >
                                        {this.props.ForEquipment ? Default_drop_down_value_Unselected :Default_drop_down_value}
                                        {buildings_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.building}>{selecterrortext}</span>
                                </Col> : ""

                        }
                        {
                            (tenant.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.tenant) ? "errortext workorderlbl" : "workorderlbl"}>{(tenant[0].required) ? tenant[0].fieldLabel + "*" : tenant[0].fieldLabel}</Label><br />
                                    <input type="text" ref='tenants_in_Select_input' value={this.state.TenantName} style={{ width: '100%', height: '15' }} className={(this.state.error.tenant) ? "errorhighlight minimal workorderedit-dropdown" : "minimal workorderedit-dropdown"} placeholder={label['WorkOrders.DropDown.Default.Text']} onClick={this.ComputeStyle} />
                                    <span hidden={!this.state.error.tenant}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (floor.length > 0 && space.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.space || this.state.error.floor) ? "errortext workorderlbl" : "workorderlbl"}>{(floor[0].required || space[0].required) ? floor[0].fieldLabel + ('/') + space[0].fieldLabel + '*' : floor[0].fieldLabel + ('/') + space[0].fieldLabel}</Label><br />
                                    <input type="text" ref='Spaces_in_Select_input' value={this.state.RoomName} style={{ width: '100%', height: '15' }} className={(this.state.error.space || this.state.error.floor) ? "errorhighlight minimal workorderedit-dropdown" : "minimal workorderedit-dropdown"} placeholder={label['WorkOrders.DropDown.Default.Text']} onClick={this.ComputeSpaceStyle} />
                                    <span hidden={!(this.state.error.space || this.state.error.floor)}>{selecterrortext}</span>
                                </Col> : ""
                        }
                    </FormGroup>
                    <FormGroup row style={{ "margin-left":"0px" }}>
                        {
                            (problem.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.problem) ? "errortext workorderlbl" : "workorderlbl"} >{(problem[0].required) ? problem[0].fieldLabel + "*" : problem[0].fieldLabel}</Label><br />
                                    <select ref='problems_in_Select_input' className={(this.state.error.problem) ? "errorhighlight minimal workorderedit-dropdown" : "minimal workorderedit-dropdown"} style={{width: '100%', "color" : "gray"}} onChange={this.SelectProblem}>
                                        {Default_drop_down_value}
                                        {problems_in_Select_input}
                                    </select>
                                    <span hidden={!this.state.error.problem}>{selecterrortext}</span>
                                </Col> : ""
                        }
                        {
                            (equipment.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 4 : 2 }}>
                                    <Label className={(this.state.error.equip) ? "errortext workorderlbl" : "workorderlbl"}>{(equipment[0].required) ? equipment[0].fieldLabel + "*" : equipment[0].fieldLabel}</Label><br />
                                    <input type="text" ref='equipments_in_Select_input' value={this.state.EquipmentName} style={{ width: '100%' }} className={(this.state.error.equip) ? "errorhighlight minimal workorderedit-dropdown" : "minimal workorderedit-dropdown"} placeholder={label['WorkOrders.DropDown.Default.Text']} onClick={this.ComputeEquipmentStyle} />
                                    <span hidden={!this.state.error.equip}>{selecterrortext}</span>
                                </Col> : ""
                        }
                    </FormGroup>
                    {lstCustomFields}
                    <FormGroup row>
                        {
                            (description.length > 0) ?
                                <Col sm={{ size: this.props.ForEquipment ? 12 : 8 }} style={{'margin-left':'15px'}}>
                                    <Label className={(this.state.error.description) ? "errortext workorderlbl" : "workorderlbl"}>{(description[0].required) ? description[0].fieldLabel + "*" : description[0].fieldLabel}</Label><br />
                                    <textarea ref='description' style={{width: this.props.ForEquipment ? '100%' : '90%','resize':'none'}} rows="7"  maxLength="1000" value={this.state.Description} className={(this.state.error.description) ? "errorhighlight workorderedit-textarea workorderheaderlbl" : "workorderedit-textarea workorderheaderlbl"} onChange={evt => this.updateDescriptionValue(evt)} />
                                    <span hidden={!this.state.error.description}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                        <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></span>
                                </Col> : ""
                        }
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{size:this.props.ForEquipment ? 12 : 8}}>
                        <div style={{width:this.props.ForEquipment ? '100%' : '90%', marginLeft:'15px'}}>
                            <Label className="workorderlbl">{label['WorkOrders.Heading.Attachments.Text']}</Label>
                            <Label className="workorderedit-choosebtn" style={{float:'right'}}>
                                <input type="file" id="myfile" onChange={(e) => this._handleAttachment(e)} />{label['WorkOrderEdit.ChooseFile.Text']}
                            </Label>
                        </div>
                        </Col>
                        <Col sm={{ size: this.props.ForEquipment ? 12 : 8 }} style={{'margin-left':'15px'}}>
                            <Table responsive className="attachmentTable" style={{width: this.props.ForEquipment ? "100%" : "90%"}}>
                                <tbody>
                                    <tr><th width="90%">ATTACHMENTS</th><th width="10%">{" "}</th></tr>
                                        {Attachment_Table}  
                                        {(this.state.displayImageError) ? error_record : null }
                                </tbody>
                            </Table>
                            <Label className="workorderlbl-noentry">{label['WorkOrderEdit.FileTypes.Text']}</Label>
                        </Col>
                    </FormGroup>
                    
                    </div>
                    <br/>
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                        { (assignedto.length > 0) ? 
                            <div style={{'margin-bottom':'5px'}}><p style={{'float':'right','margin-bottom':'0px','margin-right': this.props.ForEquipment ? '70px' : '85px'}} >
                                <input type="checkbox" style={{'vertical-align':'middle'}} id="assigned_box" disabled={!HasMailSetting || !this.state.HasEmailAddress} defaultChecked={false} ref="ref_Assigned_User" /> Notify assignee
                            </p><br/></div> : ""
                        }
                            <Button className="wo_cancel_btn" style={{'float': 'right', 'margin-left': '6px', 'margin-right': this.props.ForEquipment ? '-200px' : '0px'}} onClick={this.OnCancel}>{label['WorkOrders.Button.Cancel.Text']}</Button>
                            <Button className="wo_save_btn" style={{'float': 'right','margin-right': this.props.ForEquipment ? '-106px' : '0px'}} onClick={this.OnSaveWorkOrder} disabled={this.state.IsClickSave} > {label['WorkOrders.Button.Create.Text']}</Button>
                        </Col>
                    </FormGroup>
                </Form>
                <SearchableDropDown name="tenantdropdown" refMethod={this.setWrapperRef} groupname="rdTenant" data={this.state.TenantData} selectedID={this.state.TenantId} selectedLocation={this.state.TenantLocation} elementStyle={this.state.TenantDropDownStyles} setValue={this.setTenant} />
                <SearchableEquipmentDropDown name="Equipmentdropdown" refMethod={this.setEquipmentWrapperRef} groupname="rdEquipment" data={this.state.EquipmentData} selectedID={this.state.EquipmentId} selectedLocation={this.state.EquipmentLocation} elementStyle={this.state.EquipmentDropDownStyles} setValue={this.setEquipment} />
                <SearchableSpaceDropDown name="Spacedropdown" refMethod={this.setSpaceWrapperRef} groupname="rdSpace" data={this.state.SpacesData} selectedID={this.state.RoomId !== 0 ? this.state.RoomId : this.state.FloorId} elementStyle={this.state.SpacesDropDownStyles} setValue={this.setSpace} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getTenantList: state.tenantsRootReducer.TenantsList,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getBuildingEquipments: state.WorkorderRootReducer.BuildingsEquipments,
        getTenantAssociations: state.WorkorderRootReducer.TenantAssociations,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getEquipments: state.WorkorderRootReducer.WorkorderEquipments,
        getMailSetting: state.WorkorderRootReducer.MailSetting,
        getCustomFields: state.WorkorderRootReducer.WorkOrderCustomFields,
        getUniqueAttachmentName: state.WorkorderRootReducer.UniqueAttachmentName,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        makeGetCall: () => dispatch(makeGetCall()),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        GetWorkOrderBuildingsEquipments: (BuildingId) => dispatch(GetWorkOrderBuildingsEquipments(BuildingId)),
        DeleteAttachment: (lineitem) => dispatch(DeleteAttachment(lineitem)),
        SaveWorkOrder: (data, id) => dispatch(SaveWorkOrder(data, id)),
        GetBuildingAssociation: (TenantId) => dispatch(GetBuildingAssociation(TenantId)),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician()),
        GetWorkOrderEquipments: () => dispatch(GetWorkOrderEquipments()),
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata)),
        GetCustomFields: () => dispatch(GetCustomFields()),
        SaveAttachmentToFolder: (file, AttachmentId) => dispatch(SaveAttachmentToFolder(file, AttachmentId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateWorkOrder);